module.exports = __webpack_public_path__ + "img/LogoNO-type.sort.0e2b6f00.png";